import React, { useEffect, useState } from "react";
import { Navbar, Nav, Image, NavDropdown } from "react-bootstrap";
import { schedules } from "../../Services";

const NavBar = (props) => {
  const [todayWharf, setTodayWharf] = useState("");
  const [todayTargrin, setTodayTargrin] = useState("");
  const [todayName, setTodayName] = useState("");
  const [todayVessel, setTodayVessel] = useState(""); // <-- Add vessel state

  useEffect(() => {
    const days = [
      "SUNDAY",
      "MONDAY",
      "TUESDAY",
      "WEDNESDAY",
      "THURSDAY",
      "FRIDAY",
      "SATURDAY",
    ];
    const today = new Date();
    const todayDay = days[today.getDay()];
    setTodayName(todayDay);

    schedules()
      .then((schedulesArr) => {
        const todaySchedule = schedulesArr.find(
          (s) => s.day === todayDay && s.active
        );
        setTodayWharf(
          todaySchedule && todaySchedule.departureTimeGovtWharf
            ? todaySchedule.departureTimeGovtWharf
            : "No run"
        );
        setTodayTargrin(
          todaySchedule && todaySchedule.departureTimeTargrin
            ? todaySchedule.departureTimeTargrin
            : "No run"
        );
        setTodayVessel(
          todaySchedule && todaySchedule.vessel ? todaySchedule.vessel : "N/A"
        );
      })
      .catch(() => {});
  }, []);

  let user = localStorage.getItem("user");
  if (user) {
    user = JSON.parse(user);
  }

  const handleLogout = () => {
    // Call the original logout function from props, which should clear localStorage
    props.logout();
    // Redirect to the homepage, which forces a reload of the page and its state
    window.location.href = "/";
  };

  return (
    <>
      <Navbar bg="light" expand="sm">
        <Navbar.Brand
          href="/"
          style={{ display: "flex", alignItems: "center" }}
        >
          <img
            src={require("../../images/Eticketlogo.png")}
            alt="Logo"
            style={{ height: 36, marginRight: 12, borderRadius: "50%" }}
          />
          Ferry E-Ticketing
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto">
            <Nav.Link href="/">{"Buy Tickets"}</Nav.Link>
            {user ? (
              <>
                <Nav.Link href="/reservations">
                  {user.userRole === "employee" ? "Sold Tickets" : "My Tickets"}
                </Nav.Link>
                <Nav.Link href="/contact">{"Contact Us"}</Nav.Link>
                <NavDropdown title={user.fname} id="nav-dropdown" alignRight>
                  <NavDropdown.Item href="/account">
                    Account Settings
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item onClick={handleLogout}>
                    Sign out
                  </NavDropdown.Item>
                </NavDropdown>

                {user.imageUrl ? (
                  <Image src={user.imageUrl} width={40} />
                ) : (
                  <Image src={require("../../images/login.png")} width={40} />
                )}
              </>
            ) : (
              <>
                <Nav.Link href="" onClick={props.handleLoginShow}>
                  Sign In
                </Nav.Link>
                <Nav.Link href="" onClick={props.handleRegisterShow}>
                  Register
                </Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      <div
        style={{
          position: "relative",
          width: "100%",
          height: "200px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <Image
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            filter: !user ? "brightness(0.7)" : undefined,
          }}
          src={require("../../images/airport.jpg")}
        />

        <div
          className="p-4 shadow text-center"
          style={{
            maxWidth: 800,
            width: "100%",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "rgba(255,255,255,0.95)",
            borderRadius: 8,
          }}
        >
          <div>
            <h4 className="mb-3">Welcome to the Ferry E-Ticketing System.</h4>
            <div
              style={{
                fontWeight: 500,
                fontSize: 16,
                color: "#222",
                background: "#f8f9fa",
                borderRadius: 8,
                padding: "12px 18px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                display: "flex",
                flexWrap: "wrap", // Allow items to wrap on small screens
                gap: "16px 24px", // Add vertical and horizontal gap
                justifyContent: "center",
                alignItems: "flex-start",
              }}
            >
              {/* Vessel Info */}
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <span role="img" aria-label="ship" style={{ fontSize: 28 }}>
                  🛳️
                </span>
                <div>
                  <strong style={{ color: "#00c642ff", display: "block" }}>
                    {todayName} Vessel:
                  </strong>
                  <span style={{ color: "#333", marginTop: "4px" }}>
                    {todayVessel}
                  </span>
                </div>
              </div>

              {/* Govt Wharf Info */}
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <span role="img" aria-label="wharf" style={{ fontSize: 28 }}>
                  🏢
                </span>
                <div>
                  <strong style={{ color: "#a5b3bdff", display: "block" }}>
                    Govt Wharf:
                  </strong>
                  <span style={{ color: "#333", marginTop: "4px" }}>
                    {todayWharf}
                  </span>
                </div>
              </div>

              {/* Targrin Info */}
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <span role="img" aria-label="ferry" style={{ fontSize: 28 }}>
                  ⛴️
                </span>
                <div>
                  <strong style={{ color: "#0072c6", display: "block" }}>
                    Targrin:
                  </strong>
                  <span style={{ color: "#333", marginTop: "4px" }}>
                    {todayTargrin}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NavBar;
